module.exports = __webpack_public_path__ + "img/bg22.ee91766c.png";